

function Links() {
  return (
    <div className="links-section">
      <h1>Find Me Online</h1>
      <ul className="links-list">
        <li>
          <a href="https://github.com/Jonathan-MacDuff" target="_blank" rel="noopener noreferrer">GitHub</a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/jonathan-macduff/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </li>
        <li>
          <a href="https://medium.com/@jonathan-macduff" target="_blank" rel="noopener noreferrer">Medium</a>
        </li>
      </ul>
    </div>
  );
}

export default Links;